import { z } from 'zod';
import { publicPostSchema, publicProfileSchema } from './api.js';
const objectStatsSchema = z.object({
    day: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    week: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    month: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    quarter: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    year: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
});
const objectStatsWithAllSchema = objectStatsSchema.extend({
    all: z.number(),
});
export const publicPostWithActivityScoreSchema = publicPostSchema.extend({
    activityScore: z.number(),
});
export const publicProfileWithActivityScoreSchema = publicProfileSchema.extend({
    activityScore: z.number(),
});
const topPostsListSchema = publicPostWithActivityScoreSchema.array().max(5);
const _topProfilesListSchema = publicProfileWithActivityScoreSchema
    .array()
    .max(5);
export const topPostsSchema = z.object({
    day: topPostsListSchema,
    week: topPostsListSchema,
    month: topPostsListSchema,
    quarter: topPostsListSchema,
    year: topPostsListSchema,
});
export const topProfilesSchema = z.object({
    day: publicProfileWithActivityScoreSchema.array().max(5),
    week: publicProfileWithActivityScoreSchema.array().max(5),
    month: publicProfileWithActivityScoreSchema.array().max(5),
    quarter: publicProfileWithActivityScoreSchema.array().max(5),
    year: publicProfileWithActivityScoreSchema.array().max(5),
});
export const profilesStatsSchema = z.object({
    all: objectStatsWithAllSchema,
    active: objectStatsWithAllSchema,
});
export const postsStatsSchema = z.object({
    all: objectStatsWithAllSchema,
    withoutReply: objectStatsWithAllSchema,
    withReplies: objectStatsWithAllSchema,
    replies: objectStatsWithAllSchema,
});
export const interactionsStatsSchema = z.object({
    all: objectStatsWithAllSchema,
});
export const jamsStatsSchema = z.object({
    sessions: objectStatsWithAllSchema,
    participants: objectStatsWithAllSchema,
});
export const topListsStatsSchema = z.object({
    posts: topPostsSchema,
    profiles: topProfilesSchema,
});
export const timelinesStatsSchema = z.object({
    signups: z.object({
        week: z
            .object({
            name: z.string(),
            count: z.number(),
        })
            .array(),
        fourWeeks: z
            .object({
            name: z.string(),
            count: z.number(),
        })
            .array(),
        fourMonths: z
            .object({
            name: z.string(),
            count: z.number(),
        })
            .array(),
    }),
});
export const serverCountsSchema = z.object({
    profiles: z.number(),
    posts: z.number(),
    events: z.number(),
    reactions: z.number(),
    rsvps: z.number(),
});
export const adminServerStatsSchema = z.object({
    profiles: profilesStatsSchema,
    posts: postsStatsSchema,
    interactions: interactionsStatsSchema,
    jams: jamsStatsSchema,
    topLists: topListsStatsSchema,
    timelines: timelinesStatsSchema,
});
